import type { CourseAccreditationByProfession } from "@brookbush/types";

import useSWR, { type SWRResponse } from "swr";

const useCourseAccreditationsByProfession = (filter?: string) => {
	const url = filter
		? `/courses/accreditations/by-profession?filter=${filter}`
		: "/courses/accreditations/by-profession";

	const { data: accreditationsByProfession, ...rest } = useSWR(
		url,
	) as SWRResponse<CourseAccreditationByProfession[]> as {
		data: CourseAccreditationByProfession[];
	};

	return {
		accreditationsByProfession,
		...rest,
	};
};

export default useCourseAccreditationsByProfession;
